import React from 'react';

const Slot = ({image, title, text, link, tooltipText}) => (
    <div onClick= {() =>window.location.href=link} className="carousel_slot">
        <img src={image} alt=""/>
        <div><div className="tooltiptext"><span>{text}</span></div></div>
    </div>
);

export default Slot;